/**
 * Codes d'erreur metier stables.
 * Le code ne change jamais (contrat d'API) ; seul le message francais peut evoluer.
 */
export const ERROR_CODES = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_DISABLED: 'ACCOUNT_DISABLED',
    TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
    PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
    FORBIDDEN_ROLE: 'FORBIDDEN_ROLE',
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    EMAIL_ALREADY_USED: 'EMAIL_ALREADY_USED',
    CANNOT_MODIFY_SELF: 'CANNOT_MODIFY_SELF',
    LAST_ACTIVE_ADMIN: 'LAST_ACTIVE_ADMIN',
    USER_HAS_AUDIT_TRAIL: 'USER_HAS_AUDIT_TRAIL',
    NOT_FOUND: 'NOT_FOUND',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    // --- P1 : referentiels et imports ---
    PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',
    MOVEMENT_TYPE_NOT_FOUND: 'MOVEMENT_TYPE_NOT_FOUND',
    MOVEMENT_TYPE_ALREADY_EXISTS: 'MOVEMENT_TYPE_ALREADY_EXISTS',
    RECONCILIATION_TYPE_NOT_FOUND: 'RECONCILIATION_TYPE_NOT_FOUND',
    RECONCILIATION_TYPE_ALREADY_EXISTS: 'RECONCILIATION_TYPE_ALREADY_EXISTS',
    RECONCILIATION_TYPE_INACTIVE: 'RECONCILIATION_TYPE_INACTIVE',
    RECONCILIATION_NOT_FOUND: 'RECONCILIATION_NOT_FOUND',
    RECONCILIATION_ALREADY_CANCELLED: 'RECONCILIATION_ALREADY_CANCELLED',
    RECONCILIATION_SELECTION_STALE: 'RECONCILIATION_SELECTION_STALE',
    RECONCILIATION_RESIDUAL_NOT_CONFIRMED: 'RECONCILIATION_RESIDUAL_NOT_CONFIRMED',
    RECONCILIATION_SINGLE_MOVEMENT: 'RECONCILIATION_SINGLE_MOVEMENT',
    RECONCILIATION_NO_CONFLICT: 'RECONCILIATION_NO_CONFLICT',
    COMMENT_TYPE_NOT_FOUND: 'COMMENT_TYPE_NOT_FOUND',
    COMMENT_TYPE_ALREADY_EXISTS: 'COMMENT_TYPE_ALREADY_EXISTS',
    COMMENT_TYPE_INACTIVE: 'COMMENT_TYPE_INACTIVE',
    FAMILY_NOT_FOUND: 'FAMILY_NOT_FOUND',
    FAMILY_MEMBER_ALREADY_ASSIGNED: 'FAMILY_MEMBER_ALREADY_ASSIGNED',
    FAMILY_ALREADY_DECIDED: 'FAMILY_ALREADY_DECIDED',
    FAMILY_EXTENSION_NOT_FOUND: 'FAMILY_EXTENSION_NOT_FOUND',
    IMPORT_BATCH_NOT_FOUND: 'IMPORT_BATCH_NOT_FOUND',
    IMPORT_NOT_AWAITING_CONFIRMATION: 'IMPORT_NOT_AWAITING_CONFIRMATION',
    DISCREPANCY_NOT_FOUND: 'DISCREPANCY_NOT_FOUND',
    VALIDATION_NOT_FOUND: 'VALIDATION_NOT_FOUND',
    VALIDATION_ALREADY_CANCELLED: 'VALIDATION_ALREADY_CANCELLED',
    DEFINITIVE_VALIDATION_REQUIRES_SETTLED: 'DEFINITIVE_VALIDATION_REQUIRES_SETTLED',
    IMPORT_FILE_ALREADY_IMPORTED: 'IMPORT_FILE_ALREADY_IMPORTED',
    IMPORT_FILE_INVALID: 'IMPORT_FILE_INVALID',
    IMPORT_FAILED: 'IMPORT_FAILED',
};
export function isApiErrorBody(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const candidate = value;
    return typeof candidate.code === 'string' && typeof candidate.message === 'string';
}
//# sourceMappingURL=errors.js.map